import Phaser from 'phaser';
import { GAME_W, GAME_H } from './game/config.ts';
import { UI } from './assets/palette.ts';
import { BootScene } from './game/scenes/BootScene.ts';
import { MenuScene } from './game/scenes/MenuScene.ts';
import { PlayScene } from './game/scenes/PlayScene.ts';

// A single static-asset SPA/game (per TECH_STACK): Phaser 4 + Vite.
new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  width: GAME_W,
  height: GAME_H,
  backgroundColor: UI.skyTop,
  // FIT keeps the whole playfield visible and centered on any screen/tablet.
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  render: { antialias: true, roundPixels: false },
  scene: [BootScene, MenuScene, PlayScene],
});
